const commentsData = [
  {
    name: '电影迷小张',
    text: '小草影院真的太良心了！不用注册就能看高清电影，画质清晰播放流畅，比我之前用的那些免费站好太多了。现在每天下班回家第一件事就是打开小草影院追剧，推荐给了身边所有朋友！',
    time: '3天前',
    avatar: '张',
  },
  {
    name: '追剧达人小王',
    text: '作为一个重度影视爱好者，我用过很多免费的观影平台，小草影院是目前体验最好的。资源更新快，院线新片上线速度一流，而且真的没有广告弹窗骚扰。手机端体验也超棒，通勤路上就能追一集。',
    time: '5天前',
    avatar: '王',
  },
  {
    name: '科幻迷老李',
    text: '在小草影院刷完了《流浪地球》全系列和所有国产科幻片，资源真的太全了！从经典老片到最新热映都有，而且还做了专题合集方便找片。作为一个免费的网站能做到这样，真的佩服！希望一直保持下去。',
    time: '1周前',
    avatar: '李',
  },
  {
    name: '宝妈悠悠',
    text: '带孩子看动画片发现了小草影院，画面清晰不说，关键是没有乱七八糟的弹窗广告，给孩子看很放心。动漫专区分类很细，国产动画和日本动漫都有，宫崎骏全集都在这里看的，强烈推荐给有娃家庭！',
    time: '2周前',
    avatar: '悠',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">观众热评</h2>
          <p className="text-sm text-foreground-500">来自小草影院观众的真实反馈，看看大家怎么说。</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {commentsData.map((comment, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-6 border border-background-200/60">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-sm font-bold text-primary-600 shrink-0">
                  {comment.avatar}
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
                <div className="ml-auto flex items-center gap-0.5 text-accent-500">
                  {[1,2,3,4,5].map(s => (
                    <i key={s} className="ri-star-fill text-xs"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}